import { Card, CardContent, Typography } from "@mui/material";
import { PieChart } from "@mui/x-charts/PieChart";

const venueTypeData = [
  { id: 0, value: 35.6, label: "Unknown" },
  { id: 1, value: 25.3, label: "Church" },
  { id: 2, value: 19.9, label: "Hall" },
  { id: 3, value: 9.6, label: "Other" },
  { id: 4, value: 4.8, label: "Chapel" },
  { id: 5, value: 2.1, label: "Funeral Parlour" },
  { id: 6, value: 1.4, label: "Private Residence" },
  { id: 7, value: 0.7, label: "Tent" },
  { id: 8, value: 0.3, label: "Crematorium" },
];

export default function VenueTypesWidget() {
  return (
    <Card sx={{ height: "100%", borderRadius: 3, width: "100%" }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Venue Types
        </Typography>

        <PieChart
          series={[
            {
              data: venueTypeData,
              highlightScope: { fade: "global", highlight: "item" },
              faded: { innerRadius: 30, additionalRadius: -10 },
            },
          ]}
          height={348}
        />
      </CardContent>
    </Card>
  );
}
